import Image from 'next/legacy/image';
import signature from '../../assets/hfh/signature.png';
import team from '../../assets/hfh/team.png';
import { A } from '../../components/general/link';
import { HopeForHomes } from '../../components/img/svgs';
import { Meta } from '../../components/meta/meta';
import { DonateForm } from '../donate';

export default function HopeForHomes2023() {
  return (
    <main>
      <Meta title="Hope for Homes" description="Beds for Kids Corporate Partners" />
      {/* <section className="relative h-[65vh] w-full overflow-hidden">
        <Image
          alt="Beds for Kids Warehouse"
          src={hero}
          layout="fill"
          objectFit="cover"
          className="z-0"
          quality={100}
          priority
        />
        <div className="pointer-events-none absolute left-0 right-0 -bottom-[1px]">
          <WhiteArch />
        </div>
      </section> */}
      <section className="bg-white px-4 pb-12 pt-16 text-blue-500">
        <div className="mx-auto max-w-3xl">
          <HopeForHomes />
        </div>
        {/* <h2 className="mt-4 text-center font-caliban text-4xl leading-8 text-green-500 md:text-5xl">2023</h2> */}
      </section>
      <section className="mx-auto flex max-w-3xl justify-center bg-white px-4 pb-24 text-center text-blue-500">
        <div className="flex flex-col gap-4">
          <p className="text-xl">
            Since 2011 we have delivered <b>17,806 beds</b>, <b>165,640 total units of furniture</b> and impacted over{' '}
            <b>5,800 Charlotte families</b>. This year alone we are on pace to do a record setting{' '}
            <b className="text-green-500">715 deliveries</b>!
          </p>
          <p className="text-xl">
            As we plan for 2023 and how best to serve our Charlotte neighbors, we are launching the Hope for Homes
            Fundraiser. Based on the increase in referrals and economic trends we anticipate the need for our services
            to grow by at least 36%. The families we serve will be the most affected by increased inflation and a
            recession. In September and October we received 94 and 92 client family referrals, respectively.{' '}
            <b>
              If that pace continues into 2023, we will deliver to{' '}
              <span className="text-green-500">1,116 families in the coming year</span>, equating to an{' '}
              <span className="text-green-500">additional 401 families served</span>.
            </b>
          </p>
          <div className="grid items-center gap-4 lg:grid-cols-2">
            <p className="text-xl">
              While this number seems daunting, Beds for Kids is positioned to serve that need. For example, in one year
              in our new 17,000 sqft warehouse we have been able to execute three of the largest bulk pickups in our
              organization&#39;s history totaling over 4,000 units of furniture. Additionally, we have strengthened
              furniture relationships with Broad River Retail, Mattress Grove, Article and Rooms To Go and been able to
              successfully receive large furniture donations from them with our expanded space. We are sourcing
              furniture in the most cost efficient way possible while still creating a dignifying delivery experience
              with quality items for our families.
            </p>
            <A href="/who-we-are#staff">
              <Image src={team} alt="Beds for Kids Team" className="rounded-md" />
              <figcaption>
                Front Row: Timmy, Lauren, Chloe, Moses
                <br />
                Back Row: Will, Amari, Zach, Noel
              </figcaption>
            </A>
          </div>
          <p className="text-xl">
            <b>
              Beds for Kids has strong momentum, but we need your help to raise funds for the cost of{' '}
              <span className="text-green-500">401 additional client family deliveries in 2023.</span>
            </b>{' '}
            For $200 you can provide a twin bed set including mattress, box spring and frame to a child sleeping on the
            floor; $720 covers the average cost of a full home delivery.
          </p>
          <div className="mx-auto my-4 max-w-lg text-left text-xl">
            <p className="text-center">
              <b className="text-green-500">
                Here are four direct ways you can contribute to our Hope for Homes Fundraiser:
              </b>
            </p>
            <ul className="mx-4 mt-2 list-disc">
              <li>
                <A href="#donate">Donate below!</A>
              </li>
              <li>Mail a donation to 1800 Camden Rd. Suite 107-17 Charlotte, NC 28203</li>
              <li>
                <A href="#donate">
                  Join the Home Team and become a monthly donor. For $60 a month you can provide a full house of
                  furniture across a year!
                </A>
              </li>
              <li className="font-bold">Share our Hope for Homes Fundraiser with your friends and family!</li>
            </ul>
          </div>
          <p className="text-xl">
            Our team at Beds for Kids wishes you a wonderful holiday season! We hope you will consider our organization
            as you plan your year end giving.
          </p>
          <div className="mt-8 text-left">
            <p>Best,</p>
            <div className="grid items-end lg:grid-cols-3">
              <div>
                <div className="max-w-[150px] lg:-mb-4 lg:-ml-16 lg:-mt-2 lg:max-w-none lg:pr-16">
                  <Image src={signature} alt="Lauren Evans Signature" />
                </div>
                <p>
                  Lauren Evans
                  <br />
                  Executive Director
                </p>
              </div>
              <p className="mt-2 lg:col-span-2 lg:mt-0">
                The Beds for Kids Team
                <br />
                Zach, Moses, Chloe, Will, Jack, Lance, Noel, Timmy & Amari
              </p>
            </div>
          </div>
        </div>
      </section>
      <section id="donate" className="pb-16">
        <DonateForm />
      </section>
    </main>
  );
}
